module.exports = __webpack_public_path__ + "img/sld_delta_star_transformer_t1_b1_dark.f7a60246.svg";